import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/bazaar";

export default class Bazaar extends Page {
  title = "bazaar";

  template = templateDefault;

  onLoad(data) {
    super.onLoad(data);

    this.getApp().addScripts();

    this.scrollToTop();
  }
}
